import React from "react";

// Official vector brand paths
export function IconMeta({ size = 18, className = "" }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-label="Meta">
      <path d="M12 7.042c-2.072 0-3.87 1.096-4.87 2.748-.48-.828-1.144-1.528-1.94-2.046C4.168 7.07 2.99 6.64 1.77 6.64.79 6.64 0 7.43 0 8.41c0 .98.79 1.77 1.77 1.77.78 0 1.51.27 2.1.75.56.45 1.01 1.08 1.3 1.81.4 1.02.6 2.14.6 3.26 0 1.12-.2 2.24-.6 3.26-.29.73-.74 1.36-1.3 1.81-.59.48-1.32.75-2.1.75-.98 0-1.77.79-1.77 1.77 0 .98.79 1.77 1.77 1.77 1.22 0 2.4-.43 3.42-1.104.796-.518 1.46-1.218 1.94-2.046 1 1.652 2.798 2.748 4.87 2.748 2.072 0 3.87-1.096 4.87-2.748.48.828 1.144 1.528 1.94 2.046 1.02.674 2.2 1.104 3.42 1.104.98 0 1.77-.79 1.77-1.77 0-.98-.79-1.77-1.77-1.77-.78 0-1.51-.27-2.1-.75-.56-.45-1.01-1.08-1.3-1.81-.4-1.02-.6-2.14-.6-3.26 0-1.12.2-2.24.6-3.26.29-.73.74-1.36 1.3-1.81.59-.48 1.32-.75 2.1-.75.98 0 1.77-.79 1.77-1.77 0-.98-.79-1.77-1.77-1.77-1.22 0-2.4.43-3.42 1.104-.796.518-1.46 1.218-1.94 2.046-1-1.652-2.798-2.748-4.87-2.748z" />
    </svg>
  );
}

export function IconGitHub({ size = 18, className = "" }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-label="GitHub">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.032 1.53 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
    </svg>
  );
}

export function IconWhatsApp({ size = 18, className = "" }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-label="WhatsApp">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.05 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

export function IconEmail({ size = 18, className = "" }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-label="Email">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  );
}

export function IconInstagram({ size = 18, className = "" }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-label="Instagram">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

export function FooterContacts() {
  return (
    <div className="footer-contacts-bar">
      <div className="footer-meta-badge">
        <IconMeta size={18} className="meta-brand-icon" />
        <span>Meta Authenticated Technology Provider</span>
      </div>

      <div className="footer-discrete-links">
        <a
          href="https://wa.me/5521988407505"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link-chip"
          title="Executive WhatsApp"
        >
          <IconWhatsApp size={16} />
          <span>+55 21 98840-7505</span>
        </a>

        <a
          href="https://wa.me/5521974445234"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link-chip"
          title="Operations WhatsApp"
        >
          <IconWhatsApp size={16} />
          <span>+55 21 97444-5234</span>
        </a>

        <a
          href="mailto:lucas@automatrix-ia.com"
          className="footer-link-chip"
          title="Direct Email"
        >
          <IconEmail size={16} />
          <span>lucas@automatrix-ia.com</span>
        </a>

        <a
          href="https://github.com/Morfeu333"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link-chip"
          title="GitHub Profile & Repositories"
        >
          <IconGitHub size={16} />
          <span>GitHub (Morfeu333)</span>
        </a>

        <a
          href="https://instagram.com/automatrix.ia"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link-chip"
          title="Instagram"
        >
          <IconInstagram size={16} />
          <span>@automatrix.ia</span>
        </a>
      </div>
    </div>
  );
}
